import { MRT_PaginationState } from "material-react-table";
import { httpClient } from "src/shared/services/httpClient";

export const getManageCaseApplication = (caseId: number) =>
  httpClient.get(`chamber/manageAadeCaseApplication?case_id=${caseId}`);

export const getDiffForSubcase = (subcase_id: number) => {
  return httpClient.get(`chamber/getSubcaseDiff?subcase_id=${subcase_id}`);
};

export const getAssignUsers = (case_id: number) => {
  return httpClient.get(`chamber/assignAadeCase?case_id=${case_id}`);
};

export const assignUser = (data: {
  case_id: number | null;
  chamber_user: number;
  message: string | undefined;
}) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value?.toString() ?? "");
  });

  return httpClient.post("chamber/forwardAadeCaseToChamber", formData);
};

export const getUnregisteredCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
) => {
  const endpoint = "chamber/getUnRegisteredAadeCases";
  return httpClient.get(endpoint, {
    params: { ...filters, ...paginationState },
  });
};

export const getAdminActiveAadeCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
) =>
  httpClient.get("admin/adminActiveAadeCases", {
    params: { ...filters, ...paginationState },
  });

export const getAdminPastAadeCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
) =>
  httpClient.get("admin/adminPastAadeCases", {
    params: { ...filters, ...paginationState },
  });

export const getAdminUnregisteredAadeCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
) =>
  httpClient.get("admin/adminUnregisteredAadeCases", {
    params: { ...filters, ...paginationState },
  });

export const finishSubcase = ({
  subcaseId,
  decisionStatus,
  decisionComments,
}: {
  subcaseId: number;
  decisionStatus: string;
  decisionComments: string;
}) => {
  const formData = new FormData();

  formData.append("subcase_id", subcaseId.toString());
  formData.append("decisionStatus", decisionStatus ?? "");
  formData.append("decisionComments", decisionComments ?? "");

  return httpClient.post("chamber/finalizeSubcase", formData);
};

export const getChamberUsers = () => httpClient.get("chamber/chamberUsers");

export const getLegalTypes = () =>
  httpClient.get("chamber/availableLegalTypes");

export const getChamberList = () => httpClient.get("admin/getChambersList");

export const getActiveAadeCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
  fetchForEntireChamber: Boolean,
) => {
  const endpoint = "chamber/activeAadeCases";

  return httpClient.get(endpoint, {
    params: { ...filters, ...paginationState, fetchForEntireChamber },
  });
};

export const getPastAadeCases = (
  filters: Object,
  paginationState: MRT_PaginationState,
  fetchForEntireChamber: Boolean,
) => {
  return httpClient.get("chamber/pastAadeCases", {
    params: { ...filters, ...paginationState, fetchForEntireChamber },
  });
};

export const refreshAadeData = (caseId: number) =>
  httpClient.get("chamber/refreshAadeData", { params: { caseId: caseId } });
